import { ColumnsType } from 'antd/lib/table';
import { ReactNode } from 'react';
import { TFunction } from 'i18next';
import {
  formatPositionHistoryDate,
  getPositionHistoryDurationInDays,
} from 'app/modules/machine-inventory/utils/positionHistoryUtils';
import { EquipmentPositionSummary } from 'app/modules/machine-inventory/interfaces/MachinePosition.types';

interface GetMachineDetailsPositionColumnsOptions {
  t: TFunction;
}

export const getMachineDetailsPositionColumns = ({
  t,
}: GetMachineDetailsPositionColumnsOptions): ColumnsType<EquipmentPositionSummary> => [
  {
    key: 'index',
    dataIndex: 'index',
    width: 44,
    render: (_, __, index) => (index + 1).toString().padStart(2, '0'),
  },
  {
    key: 'enteredAt',
    dataIndex: 'enteredAt',
    width: 112,
    title: t('machineDetailsPanel.positionHistory.table.entry') as string,
    render: enteredAt => formatPositionHistoryDate(enteredAt as string),
  },
  {
    key: 'exitedAt',
    dataIndex: 'exitedAt',
    width: 112,
    title: t('machineDetailsPanel.positionHistory.table.exit') as string,
    render: exitedAt => (exitedAt ? formatPositionHistoryDate(exitedAt as string) : '-'),
  },
  {
    key: 'duration',
    dataIndex: 'duration',
    width: 100,
    title: t('machineDetailsPanel.positionHistory.table.duration') as string,
    render: (_, record): ReactNode =>
      t('machineDetailsPanel.positionHistory.dayCount', {
        count: getPositionHistoryDurationInDays(record),
      }) as string,
  },
  {
    key: 'address',
    dataIndex: 'address',
    width: 320,
    title: t('machineDetailsPanel.positionHistory.table.position') as string,
    ellipsis: {
      showTitle: true,
    },
    render: address => address || '-',
  },
  {
    key: 'accuracy',
    dataIndex: 'accuracy',
    width: 90,
    title: t('machineDetailsPanel.positionHistory.table.accuracy') as string,
    render: (accuracy): ReactNode => {
      if (accuracy === null || accuracy === undefined) return '-';

      return t('machineDetailsPanel.positionHistory.accuracyValue', {
        accuracy: Math.round(accuracy as number),
      }) as string;
    },
  },
];
